module.exports = __webpack_public_path__ + "img/oss_logo.png";